export { default as Listar } from './Listar'
export { default as Detalle } from './Detalle'
